import axios from 'axios';
import store from '../store';
export default {
  namespaced: true,
  
  state: {
    idmodal: '',
    descripcionmodal: '',
    banderamodal: null,
    colores:[],
    color:[],
    
    
  },
  mutations: {

    LoadProductos(state,buscar) {
      //let aux = [];
      state.color = state.colores;

      let aux = state.colores.filter((x) => x["nombrecolor"].toUpperCase().includes(buscar.toUpperCase()),);
      if (buscar == "") {
        state.color = state.colores;
      } else {
        state.color = aux;
      
      }
    },

    
    async  cargardatoscolores(state){
      
      state.colores = []
      var token = store.state.numero;
      await axios
      .get("https://juanabapl.juanabonita.com.co:446/Ecommerceh/api/colores", {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => {
        state.colores = response.data.data;
      
      })  .catch((e) => {
        console.log(e);
        location.reload();
      });
      state.color = state.colores
    },
    
    cambio(state,descripcion){
     state.descripcionmodal =descripcion
  
    },
    agregartable(state)  {
      
      //      this.descripcionmodal = descripcion
      var token = store.state.numero;
      var datos = {
        nombrecolor: state.descripcionmodal
      };
      this.banderamodal = store.state.banderamodal
      

      
      var datosfalso = state.idmodal;
    
      if (this.banderamodal === true) {
        
        
        axios
        
        .post("https://juanabapl.juanabonita.com.co:446/Ecommerceh/api/colores", datos, {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        })
        .then((response) => {
          let tokenn = response.data.token;
          //this.respuesta = <z<
          this.token = tokenn;
        
          
        })
        
        .catch((e) => {
          console.log(e);
          location.reload();
        });
      } else {
        
        axios
        
        .post(
          "https://juanabapl.juanabonita.com.co:446/Ecommerceh/api/colores/UpdateReg/" +
          datosfalso,
          datos,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + token,
            },
          }
          )
          .then((response) => {
            let tokenn = response.data.token;
            //this.respuesta = <z<
            this.token = tokenn;
          
          })
          
          .catch((e) => {
            console.log(e);
            location.reload();
          });
        }
        
      },
      
      
      datosmodal(state, api) {
      
        state.idmodal = api.idcolor,
        state.descripcionmodal = api.nombrecolor
        
      },
      
      
      
      eliminar(state, api) {
        var token = store.state.numero
        let eliminar = api;
 
        axios
        .get("https://juanabapl.juanabonita.com.co:446/Ecommerceh/api/colores/DeleteReg/" + eliminar,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        })
        
        
        .then((response) => {
          let tokenn = response.data.token;
          //this.respuesta = <z<
          state.eliminer = tokenn;
      
          //this.bandera = true;
        })
        
        .catch((e) => {
          console.log(e);
          location.reload();
        });
        
        
        
      },
      
      
      
    },
    actions: {
      
    },
    getters: {
      
      
    },
    
    
    



}